/**
 * EntryMethodModal.js - Modal para seleccionar método de creación de entrada
 * Opciones: Subir receta (IA) o Llenar manualmente
 */
import React from 'react';

export default function EntryMethodModal({ show, onClose, onSelectAI, onSelectManual }) {
  if (!show) return null;

  return (
    <div className="modal-overlay entry-method-overlay" onClick={onClose}>
      <div
        className="modal-content entry-method-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Registrar Visita Médica</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body" style={{ padding: '24px' }}>
          <p style={{ textAlign: 'center', marginBottom: '20px', color: '#666', fontSize: '15px' }}>
            ¿Cómo quieres registrar la visita?
          </p>

          {/* Opción 1: Tengo la receta */}
          <div
            onClick={onSelectAI}
            style={{
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              padding: '18px 20px',
              cursor: 'pointer',
              marginBottom: '12px',
              backgroundColor: '#fff',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = '#4CAF50';
              e.currentTarget.style.backgroundColor = '#f8fff8';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = '#e5e7eb';
              e.currentTarget.style.backgroundColor = '#fff';
            }}
          >
            <span style={{ fontSize: '28px', flexShrink: 0 }}>📄</span>
            <div>
              <div style={{ fontWeight: 600, color: '#374151', fontSize: '15px', marginBottom: '2px' }}>
                Tengo la receta
              </div>
              <div style={{ color: '#6b7280', fontSize: '13px' }}>
                Sube foto y se llena automáticamente
              </div>
            </div>
          </div>

          {/* Opción 2: Llenar manualmente */}
          <div
            onClick={onSelectManual}
            style={{
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              padding: '18px 20px',
              cursor: 'pointer',
              backgroundColor: '#fff',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = '#3b82f6';
              e.currentTarget.style.backgroundColor = '#f8faff';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = '#e5e7eb';
              e.currentTarget.style.backgroundColor = '#fff';
            }}
          >
            <span style={{ fontSize: '28px', flexShrink: 0 }}>✏️</span>
            <div>
              <div style={{ fontWeight: 600, color: '#374151', fontSize: '15px', marginBottom: '2px' }}>
                Llenar manualmente
              </div>
              <div style={{ color: '#6b7280', fontSize: '13px' }}>
                Captura los datos de la visita tú mismo
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        /* ========================================
           BASE STYLES - Override Bootstrap
           ======================================== */
        .entry-method-overlay {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background-color: rgba(0, 0, 0, 0.5) !important;
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          z-index: 1050 !important;
          padding: 20px !important;
        }

        .entry-method-modal {
          background: #fff !important;
          border-radius: 12px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          width: 100% !important;
          max-width: 480px !important;
          max-height: 90vh !important;
          display: flex !important;
          flex-direction: column !important;
          overflow: hidden !important;
          position: relative !important;
        }

        .entry-method-modal .modal-header {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 16px 24px !important;
          border-bottom: 1px solid #eee !important;
          flex-shrink: 0 !important;
          background: linear-gradient(135deg, #4CAF50 0%, #7AB43B 100%) !important;
        }

        .entry-method-modal .modal-header h3 {
          margin: 0 !important;
          font-size: 18px !important;
          font-weight: 600 !important;
          color: #fff !important;
        }

        .entry-method-modal .modal-close {
          background: rgba(255,255,255,0.2) !important;
          border: none !important;
          font-size: 24px !important;
          cursor: pointer !important;
          color: #fff !important;
          padding: 0 !important;
          line-height: 1 !important;
          width: 32px !important;
          height: 32px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 50% !important;
          transition: background 0.2s !important;
        }

        .entry-method-modal .modal-close:hover {
          background: rgba(255,255,255,0.3) !important;
        }

        .entry-method-modal .modal-body {
          flex: 1 !important;
          overflow-y: auto !important;
          -webkit-overflow-scrolling: touch !important;
        }

        /* ========================================
           MOBILE FULLSCREEN (<768px)
           ======================================== */
        @media (max-width: 767px) {
          .entry-method-overlay {
            padding: 0 !important;
            align-items: stretch !important;
          }

          .entry-method-modal {
            max-width: 100% !important;
            width: 100% !important;
            height: 100vh !important;
            height: 100dvh !important;
            max-height: 100vh !important;
            max-height: 100dvh !important;
            margin: 0 !important;
            border-radius: 0 !important;
          }

          .entry-method-modal .modal-header {
            padding: 16px !important;
          }

          .entry-method-modal .modal-header h3 {
            font-size: 17px !important;
          }

          .entry-method-modal .modal-close {
            font-size: 28px !important;
            width: 40px !important;
            height: 40px !important;
            margin-right: -8px !important;
          }

          .entry-method-modal .modal-body {
            padding: 20px 16px !important;
          }
        }
      `}</style>
    </div>
  );
}
